import { getRYGCount, getRYGCountYear, getRYGstatusList } from 'services/axios/rygStatus'

// Action type
const actions = {
  FETCH_RYG_STATUS_DATA: 'FETCH_RYG_STATUS_DATA',
  FETCH_RYG_COUNT: 'FETCH_RYG_COUNT',
  FETCH_RYG_YEAR_COUNT: 'FETCH_RYG_YEAR_COUNT',
}

// Action creaters
export const fetchRYGstatusData = ({ StatusFilter, skip, limit, EmployeeFilter } = {}) => {
  return async (dispatch) => {
    const response = await getRYGstatusList(StatusFilter, skip, limit, EmployeeFilter)
    dispatch({ type: actions.FETCH_RYG_STATUS_DATA, payload: response?.data?.data })
  }
}

export const fetchRYGCount = () => {
  return async (dispatch) => {
    const response = await getRYGCount()
    dispatch({ type: actions.FETCH_RYG_COUNT, payload: response?.data?.data })
  }
}

export const fetchRYGYearCount = () => {
  return async (dispatch) => {
    const response = await getRYGCountYear()
    dispatch({ type: actions.FETCH_RYG_YEAR_COUNT, payload: response?.data?.data })
  }
}

export default actions
